export const fontAwesomeData = [
    'fa-solid fa-house',
    'fa-regular fa-user',
    'fa-brands fa-facebook',
    'fa-solid fa-check',
    'fa-solid fa-download',
    'fa-brands fa-twitter',
    'fa-solid fa-image',
    'fa-regular fa-image',
    'fa-solid fa-phone',
    'fa-brands fa-tiktok',
    'fa-solid fa-bars',
    'fa-regular fa-envelope',
    'fa-solid fa-envelope',
    'fa-brands fa-linkedin',
    'fa-solid fa-star',
    'fa-solid fa-location-dot',
    'fa-brands fa-github',
    'fa-solid fa-music',
    'fa-solid fa-users',
    'fa-solid fa-heart',
    'fa-regular fa-heart',
    'fa-solid fa-arrow-right',
    'fa-brands fa-discord',
    'fa-solid fa-circle-xmark',
    'fa-solid fa-bomb',
    'fa-solid fa-poo',
    'fa-brands fa-youtube',
    'fa-solid fa-cloud',
    'fa-solid fa-comment',
    'fa-regular fa-comment',
    'fa-solid fa-caret-up',
    'fa-solid fa-truck-fast',
    'fa-brands fa-wordpress',
    'fa-solid fa-pen-nib',
    'fa-solid fa-arrow-up',
    'fa-solid fa-hippo',
    'fa-solid fa-face-smile',
    'fa-regular fa-face-smile',
    'fa-solid fa-calendar',
    'fa-regular fa-calendar',
    'fa-solid fa-paperclip',
    'fa-brands fa-slack',
    'fa-solid fa-shield-halved',
    'fa-brands fa-figma',
    'fa-regular fa-file',
    'fa-solid fa-bell',
    'fa-regular fa-bell',
    'fa-solid fa-cart-shopping',
    'fa-solid fa-clipboard',
    'fa-regular fa-clipboard',
    'fa-solid fa-filter',
    'fa-solid fa-circle-info',
    'fa-solid fa-bolt',
    'fa-solid fa-car',
    'fa-solid fa-ghost',
    'fa-brands fa-apple',
    'fa-solid fa-mug-hot',
    'fa-solid fa-circle-user',
    'fa-regular fa-circle-user',
    'fa-solid fa-pen',
    'fa-regular fa-circle-user',
    'fa-brands fa-google',
    'fa-solid fa-umbrella',
    'fa-solid fa-gift',
    'fa-solid fa-film',
    'fa-solid fa-list',
    'fa-solid fa-gear',
    'fa-solid fa-backward',
    'fa-solid fa-trash',
    'fa-solid fa-circle-up',
    'fa-regular fa-circle-up',
    'fa-brands fa-docker',
    'fa-solid fa-circle-down',
    'fa-regular fa-circle-down',
    'fa-solid fa-inbox',
    'fa-solid fa-rotate-right',
    'fa-solid fa-lock',
    "fa-solid fa-info",
    "fa-solid fa-headphones",
    "fa-solid fa-barcode",
    "fa-solid fa-book",
    "fa-solid fa-bookmark",
    "fa-brands fa-paypal",
    "fa-solid fa-print",
    "fa-solid fa-camera",
    "fa-solid fa-caret-down",
    "fa-solid fa-font",
    "fa-solid fa-video",
    "fa-solid fa-circle-half-stroke",
    "fa-solid fa-droplet",
    "fa-solid fa-pen-to-square",
    "fa-regular fa-pen-to-square",
    "fa-solid fa-share-from-square",
    "fa-regular fa-pen-to-square",
    "fa-solid fa-plus",
    "fa-solid fa-minus",
    "fa-solid fa-share",
    "fa-solid fa-circle-exclamation",
    "fa-solid fa-fire",
    "fa-solid fa-eye",
    "fa-regular fa-eye",
    "fa-solid fa-eye-slash",
    "fa-regular fa-eye",
    "fa-solid fa-scroll",
    "fa-solid fa-plane",
    "fa-solid fa-folder",
    "fa-solid fa-thumbs-up",
    "fa-regular fa-thumbs-up",
    "fa-solid fa-thumbs-down",
    "fa-regular fa-thumbs-down",
    "fa-solid fa-comments",
    "fa-solid fa-key",
    "fa-solid fa-thumbtack",
    "fa-solid fa-gears",
    "fa-solid fa-paper-plane",
    "fa-solid fa-person",
    "fa-solid fa-wifi",
    "fa-solid fa-right-to-bracket",
    "fa-solid fa-gear",
    "fa-solid fa-cloud-arrow-up",
];